<template>
  <v-container>
    <v-card>
      <v-container>
        <v-data-table
          :headers="headers"
          :items="receivers"
          :search="search"
          hide-actions
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left">{{ props.item.email }}</td>
              <td class="text-xs-left">{{ props.item.receiverName }}</td>
              <td class="text-xs-left">
                {{ props.item.isActive === true ? 'メール受信する' : 'メール受信しない' }}
              </td>
              <td class="text-xs-center">
                <v-btn
                  icon
                  small
                  aria-label="編集"
                  @click="forwardReceiverEdit(props.item)"
                >
                  <v-icon small color="primary">edit</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>          
        </v-data-table>
        <br />
      </v-container>
    </v-card>

    <br />
    <v-layout row wrap class="button-area">
      <v-flex xs12 sm6 class="button-left">
        <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
          <v-icon color="black" left>home</v-icon>{{ $t('home-btn') }}
        </v-btn>
      </v-flex>

      <v-flex xs12 sm6 class="button-right">
        <v-btn block color="success" dark :to="{ name: 'admin/order-mail-receiver/new' }">
          <v-icon dark left>create</v-icon>新規登録
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
export default {
  created() {
    ServerApiCallService.orderMailReceiver()
      .then(response => {
        this.receivers = response.data.orderMailReceivers
      })
      .catch(error => {
        console.log('There was an error: orderMailReceiver, ', error.response)
      })
  },
  methods: {
    forwardReceiverEdit(emailInfo) {
      this.$router.push({
        name: 'admin_order_mail_receiver_update',
        params: { email: emailInfo.email, isActive: emailInfo.isActive }
      })
    }
  },
  data() {
    return {
      search: '',
      headers: [
        { text: 'email', value: 'email' },
        { text: '受信者名', value: 'receiverName', sortable: false },
        { text: 'ステータス', value: 'isActive', sortable: false },
        {
          text: '編集',
          value: 'edit',
          sortable: false,
          align: 'center'
        }
      ],
      receivers: []
    }
  }
}
</script>

<style>
table.v-table thead th {
  font-size: 14px !important;  
  color: #333 !important;
}
.button-left {
  padding-right: 6px;
}

.button-right {
  padding-left: 6px;
}
.editable-row {
  cursor: pointer;
}

.editable-row:hover {
  background-color: #f5f7fa !important;
}
</style>
